var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('costs', {
    attrs: {
      "loading": _vm.isFetching,
      "sort": _vm.sort,
      "records": _vm.paginatedRecords,
      "total": _vm.totalRecords,
      "display": _vm.display,
      "page": _vm.page
    },
    on: {
      "paginate": _vm.setPage,
      "sort": _vm.setSort
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caf6696a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/costs/CostsContainer.vue
// module id = 1000
// module chunks = 0